import React, { useEffect, useState } from 'react';
import { Typography, Button, Grid, useMediaQuery, TextField, FormControl } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import CartItem from './CartItem/CartItem';
import './cart.css'
import { useSelector } from 'react-redux';
import { clearCart, getTotals } from '../../features/slices/cartSlice';
import { useDispatch } from "react-redux"
import { useGetCartQuery, useUpdateCartMutation } from '../../features/fullApi';
import { useTheme } from '@mui/material/styles';
import Error403 from '../ErrorPages/Error403'
import styled from 'styled-components';
import { toast } from 'react-hot-toast';
import emptyCart from '../Images/emptycart.png'


const MobileCart = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   padding: 10px;
`;

const Cart = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const dispatch = useDispatch()
  const cart = useSelector(state => state.cart)
  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }
  const [updateCart] = useUpdateCartMutation()
  const navigate = useNavigate()
  const {data: cartData, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user._id);
  useEffect(() => {
    dispatch(getTotals())
  }, [cart, dispatch])

  //when we get cart data, set is active to true
  useEffect(() => {
    console.log("called", cartData)
    console.log("cart error", cartError)
    if(!cartIsLoading) {
      updateCart({_id: cartData?._id, isActive: true}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      })
    }
  }, [cartIsLoading])

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  const checkIfCartIsActive = () => {
    console.log("CALLED CHECK IS CART IS ACTIVE", cartData)
    if(cartData.isActive) {
      navigate('/address')
    } else {
      console.log("on else")
      toast("Some products in your cart are not available")
    }
  }
  const [code, setCode] = useState("")
  const applySale = () => {
    console.log("code inside apply sale", code)
    if(code === "all10") {
      setReduceCode(0.9)
      setInvalideCode(false)   
      setSuccessCode(true)
    } else if (code === "all20") {
      setReduceCode(0.8)
      setInvalideCode(false)
      setSuccessCode(true)
    } else {
      setInvalideCode(true)
      setSuccessCode(false)
      setReduceCode(1)
    }
  }

  const [reduceCode, setReduceCode] = useState(1)
  const [invalidCode, setInvalideCode] = useState("")
  const [successCode, setSuccessCode] = useState("")

  const handleChangeValue = (e) => {
    setCode(e.target.value)
  }

 
  const handleClearCart = () => {
    toast('Cleared cart 🛒', {
      icon: '❌',
    });
    dispatch(clearCart())
    const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
    updateCart({_id: cartData._id, products: currentProducts, userId: cartData.userId}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    .then(res =>   
      {     
      }
    ).catch(err => console.log("err", err))
  }

  const renderEmptyCart = () => (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: 'calc(100vh - 64px)'}}>
      <Typography style={{padding: '25px 0'}}>Your shopping cart is empty</Typography>
      <img 
      src={emptyCart} 
      alt="empty shopping cart"
      className={isSm ? "mobileImg" : "deskImg"}
      />
      <Button variant="contained" color="secondary" style={{width: '100px', marginTop: '25px'}} onClick={() => navigate('/smartphones/page=1')}>Shop</Button>
    </div>
  );

  const renderDesktopCart = () => (
    <div style={{width: '1200px', margin: '0 auto', minHeight: '100vh', marginTop: '122px'}}>
      <div style={{display: 'flex'}}> 

      <div style={{paddingRight:'30px', borderRight:'1px dotted #eee', width:'900px'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ddd', alignItems: 'center'}}>
          <Typography style={{textAlign: 'center'}} variant="h5" gutterBottom>Shopping Cart</Typography>
          <Typography style={{textAlign: 'center'}} variant="h5" gutterBottom>{cart.cartTotalQuantity} items</Typography>
        </div>
        <Grid container spacing={3}>
            {cart?.cartItems?.map((item) => (
                <Grid item md={12} lg={12} xl={12} xxl={12} key={item._id}>
                  <CartItem item={item}/>
                </Grid>
            ))}
        </Grid>
      </div>

        <div style={{paddingLeft:'30px'}}>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', borderBottom: '1px solid #ddd'}}>
            <Typography variant="h5" gutterBottom>Summary</Typography>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', marginTop:'25px'}}>
            <Typography variant="h6" style={{marginBottom: '20px'}}>Items {cart.cartTotalQuantity}</Typography>
            <Typography variant="h6" style={{marginBottom: '20px'}}>${cart.cartTotalAmount * reduceCode}</Typography> 
          </div> 
          <br/>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography variant="h6" style={{marginBottom: '20px'}}>Shipping</Typography>
            <Typography variant="h6" style={{marginBottom: '20px'}}>$10</Typography> 
          </div> 
          <br/>
            <Typography variant="h6" style={{marginBottom: '20px'}}>Promo Code</Typography> 
          <br/>  
            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField style={{marginBottom: '20px'}} onChange={handleChangeValue} label="Enter code" size="small"></TextField> 
            </FormControl>
            <p style={{color:'red', fontWeight:'bold'}}>
              {invalidCode ? "You entered an invalid promo code" : ""}
            </p>
            <p style={{color:'green', fontWeight:'bold'}}>
              {successCode ? "The sale has been applied" : ""}
            </p>
       
            <Button variant="contained" color="secondary" style={{marginBottom: '25px'}} onClick={() => applySale()}>Apply</Button>
            <br/>
            <p style={{borderBottom: '1px solid #eee', padding: '0'}}></p>
          <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginTop: '25px'}}>
            {/* <Button size="large" style={{width: '200px'}} type="button" variant="contained" color="secondary" onClick={() => handleClearCart()}>Empty cart</Button> */}
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <Typography variant="h6" style={{marginBottom: '20px'}}>Total Cost</Typography>
            <Typography variant="h6" style={{marginBottom: '20px'}}>${cart.cartTotalAmount*reduceCode + 10}</Typography> 
          </div> 
            <Button component={Link} to="/address" type="button" variant="contained" color="primary">Checkout</Button>
          </div>
        </div>  
      </div>
    </div>
  )

  const renderTabletCart = () => (
    <div style={{padding: '50px', width: '100%'}}>
      <div style={{padding: '50px'}}>
          <Typography style={{textAlign: 'center', padding: '50px'}} variant="h4" gutterBottom>Your Shopping Cart</Typography>
          <Grid container spacing={3} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {cart?.cartItems?.map((item) => (
                <Grid item key={item._id}>
                  <CartItem item={item}/>
                </Grid>
            ))}
          </Grid>
        </div>
      <div style={{paddingTop: '50px'}}>
        <Typography variant="h4" style={{paddingBottom: '50px'}}>Subtotal: ${cart.cartTotalAmount} $</Typography>
        <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '10px'}}>
          <Button size="large" style={{width: '175px'}} type="button" variant="contained" color="secondary" onClick={() => handleClearCart()}>Empty cart</Button>
          <Button component={Link} to="/address" style={{width: '175px'}} size="large" type="button" variant="contained" color="primary">Checkout</Button>
        </div>
      </div>  
    </div>
  );

  const renderMobileCart = () => (
    <MobileCart>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <Typography style={{textAlign: 'center', padding: '20px'}} variant="h5" gutterBottom>My cart</Typography>
          <Grid container spacing={3} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            {cart?.cartItems?.map((item) => (
                <Grid item key={item._id}>
                  <CartItem item={item}/>
                </Grid>
            ))}
          </Grid>
      </div>
      <div style={{paddingTop: '25px', width: '100%'}}>
        <Typography variant="h6" style={{paddingBottom: '25px', textAlign: 'center'}}>Subtotal: ${cart.cartTotalAmount}</Typography>
        <div style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', paddingBottom:'20px', fontSize: '12px', width: '100%'}}>
          <Button size="large" style={{width: '125px', fontSize: 'inherit'}} type="button" variant="contained" color="secondary" onClick={() => handleClearCart()}>Empty cart</Button>
          <Button size="large" style={{width: '125px', fontSize: 'inherit'}} type="button" variant="contained" color="secondary" onClick={() => checkIfCartIsActive()}>Checkout</Button>
        </div>
      </div>  
    </MobileCart>
  );



  return (
    <div>
      {!cartError ?
        (
          !cart?.cartItems?.length ? renderEmptyCart() :
          (isXs) ?  renderMobileCart() : 
          (isSm) ? renderMobileCart() :
          (isMd) ? renderTabletCart() :
          renderDesktopCart()
        ) : (
          <Error403></Error403>
        )
      }
    </div>

  );
};

export default Cart;